import React from "react";
import { Grid, Tab } from "semantic-ui-react";
import PreReqProgramList from "./PreReqProgramList";
import YearOneProgramList from "./YearOneProgramList";
import YearTwoProgramList from "./YearTwoProgramList";
 
const panes = [
  {
    menuItem: 'Pre-Req',
    render: () => <Tab.Pane attached={false}><PreReqProgramList /></Tab.Pane>,
  },
  {
    menuItem: 'Year 1',
    render: () => <Tab.Pane attached={false}><YearOneProgramList /></Tab.Pane>,
  },
  {
    menuItem: 'Year 2',
    render: () => <Tab.Pane attached={false}><YearTwoProgramList /></Tab.Pane>,
  },
]

const Programs = () => (
  <Grid>
    <Grid.Column>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </Grid.Column>
  </Grid>
)
export default Programs;